import { render, staticRenderFns } from "./CheckboxGroupElement.vue?vue&type=template&id=62d8dd4c&scoped=true&"
import script from "./CheckboxGroupElement.vue?vue&type=script&lang=js&"
export * from "./CheckboxGroupElement.vue?vue&type=script&lang=js&"
import style0 from "./CheckboxGroupElement.vue?vue&type=style&index=0&id=62d8dd4c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d8dd4c",
  null
  
)

export default component.exports